var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    fill: "none",
    viewBox: "0 0 12 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#236A91",
    d: "M6.001.667A5.83 5.83 0 0 0 .168 6.5c0 1.45.417 2.808 1.175 4.033.792 1.284 1.833 2.384 2.633 3.667.392.625.675 1.208.975 1.883.217.459.392 1.25 1.05 1.25.659 0 .834-.791 1.042-1.25.308-.675.583-1.258.975-1.883.8-1.275 1.842-2.375 2.633-3.667.767-1.225 1.184-2.583 1.184-4.033A5.829 5.829 0 0 0 6 .667Zm0 8.125a2.084 2.084 0 1 1 .002-4.169A2.084 2.084 0 0 1 6 8.792Z"
  })));
};
export default SvgPin;